module.exports = __webpack_public_path__ + "img/bilderogdokumenter.164d80da.png";